import { render, staticRenderFns } from "./StreamInfo.vue?vue&type=template&id=60f8cab6&scoped=true&"
import script from "./StreamInfo.vue?vue&type=script&lang=js&"
export * from "./StreamInfo.vue?vue&type=script&lang=js&"
import style0 from "./StreamInfo.vue?vue&type=style&index=0&id=60f8cab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f8cab6",
  null
  
)

export default component.exports